import { __awaiter, __generator, __spreadArray, __assign } from 'tslib';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch, connect } from 'react-redux';
import { BreakpointProvider } from '@rakutenfrance/breakpoint';
import { SellerDrawer } from '@rakutenfrance/mui';
import Box from '@mui/material/Box';
import axios from 'axios';
import { useTranslate, useMarketplace, tolgeeModule, getLanguageFromRequest, getTolgee, TolgeeProvider, MarketplaceProvider } from '@rakutenfrance/tolgee-provider';
import { getLogger } from '@rakutenfrance/logger';
import { publicRuntimeConfig } from '@rakutenfrance/config-service';

var ADD_FAVORITE_SELLER_LOADING = 'ADD_FAVORITE_SELLER_LOADING';
var ADD_FAVORITE_SELLER_SUCCESS = 'ADD_FAVORITE_SELLER_SUCCESS';
var REMOVE_FAVORITE_SELLER_LOADING = 'REMOVE_FAVORITE_SELLER_LOADING';
var REMOVE_FAVORITE_SELLER_SUCCESS = 'REMOVE_FAVORITE_SELLER_SUCCESS';
var SHOW_SELLER_INFORMATION_DRAWER = 'SHOW_SELLER_INFORMATION_DRAWER';
var INIT_SELLER_INFORMATION_DRAWER = 'INIT_SELLER_INFORMATION_DRAWER';
var CLEAR_SELLER_INFORMATION_DATA = 'CLEAR_SELLER_INFORMATION_DATA';
var FETCH_SELLER_DATA_SUCCESS = 'FETCH_SELLER_DATA_SUCCESS';
var FETCH_SELLER_DATA_ERROR = 'FETCH_SELLER_DATA_ERROR';
var FETCH_SELLER_REVIEWS_SUCCESS = 'FETCH_SELLER_REVIEWS_SUCCESS';
var FETCH_SELLER_REVIEWS_ERROR = 'FETCH_SELLER_REVIEWS_ERROR';
var FETCH_SELLER_FAVORITE_DATA_SUCCESS = 'FETCH_SELLER_FAVORITE_DATA_SUCCESS';
var FETCH_SELLER_FAVORITE_DATA_ERROR = 'FETCH_SELLER_FAVORITE_DATA_ERROR';
var FETCH_SELLER_DESCRIPTION_SUCCESS = 'FETCH_SELLER_DESCRIPTION_SUCCESS';
var FETCH_SELLER_DESCRIPTION_ERROR = 'FETCH_SELLER_DESCRIPTION_ERROR';

var API = {
    favoriteSeller: '/restpublic/web/favorite/seller/',
    sellerInformation: '/restpublic/vis-web/eshopHeaderProDetails?sellerLogin=',
    sellerDescription: '/restpublic/web/shops/',
    sellerReview: '/restpublic/sel-web/sellers/',
    sellerFavorite: '/restpublic/web/favorite/seller/',
};

var headers = {};
var axiosInstance = axios.create({ headers: headers });
var service = {
    getSellerInformation: function (sellerName) {
        var apiUrl = API.sellerInformation + sellerName;
        return axiosInstance.get(apiUrl);
    },
    getSellerFavorite: function (sellerId) {
        var apiUrl = API.sellerFavorite + sellerId;
        return axiosInstance.get(apiUrl);
    },
    getSellerDescription: function (shopId) {
        var apiUrl = API.sellerDescription + shopId + '/details';
        return axiosInstance.get(apiUrl);
    },
    getSellerReviews: function (sellerId, sortType, sortOrder, numberOfResults, nextToken) {
        var apiUrl = API.sellerReview + sellerId + '/feedback?version=1&sortType=' + sortType + '&sortOrder=' + sortOrder + '&numberOfResults=' + numberOfResults;
        var urlWithToken = nextToken ? apiUrl + '&nextToken=' + nextToken : apiUrl;
        return axiosInstance.get(urlWithToken);
    },
    addSellerToFavorites: function (sellerId) {
        var apiUrl = API.favoriteSeller + sellerId;
        return axiosInstance.post(apiUrl);
    },
    removeSellerFromFavorites: function (sellerId) {
        var apiUrl = API.favoriteSeller + sellerId;
        return axiosInstance.delete(apiUrl);
    }
};

var loadPartnerFromEvent = function (partnerId, partnerName, advertId, target) {
    return function (dispatch) {
        if (partnerId) {
            dispatch({
                type: SHOW_SELLER_INFORMATION_DRAWER,
                payload: {
                    partnerId: partnerId,
                    partnerName: partnerName,
                    advertId: advertId,
                },
            });
            var params = new URLSearchParams(window.location.search);
            params.set('sellerinformation', 'true');
            params.set('partnerid', partnerId);
            params.set('partnername', partnerName);
            params.set('advertid', advertId);
            params.set('target', target);
            var hash = window.location.hash;
            var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(params.toString()).concat(hash.length > 1 ? hash : '');
            window.history.pushState({ path: newUrl }, '', newUrl);
        }
    };
};
var loadSellerLink = function () {
    return function (dispatch) {
        var params = new URLSearchParams(window.location.search);
        if (params.get('sellerinformation')) {
            dispatch({
                type: SHOW_SELLER_INFORMATION_DRAWER,
                payload: {
                    partnerId: params.get('partnerid'),
                    partnerName: params.get('partnername'),
                    advertId: params.get('advertid'),
                },
            });
        }
    };
};
var initSellerBtnListeners = function () {
    document.querySelector('body').addEventListener('click', function (e) {
        var partnerBtn = e.target.closest('[data-advert-popin]');
        if (partnerBtn) {
            e.preventDefault();
            var partnerId = partnerBtn.getAttribute('data-advert-partnerid');
            var partnerName = partnerBtn.getAttribute('data-advert-partnername');
            var advertId = partnerBtn.getAttribute('data-advert-advertid');
            var target = partnerBtn.getAttribute('data-advert-target') || 'detail';
            document.dispatchEvent(new CustomEvent('SELLER-INFORMATION-DRAWER', { detail: { partnerId: partnerId, partnerName: partnerName, advertId: advertId, target: target } }));
        }
    });
};
var dispatchShowSellerDrawer = function (dispatch, partnerFPBtn) {
    partnerFPBtn.getAttribute('data-advert-partnerid');
    partnerFPBtn.getAttribute('data-advert-partnername');
    partnerFPBtn.getAttribute('data-advert-advertid');
    partnerFPBtn.getAttribute('data-advert-target');
    dispatch({
        type: SHOW_SELLER_INFORMATION_DRAWER,
        payload: {
            partnerId: partnerFPBtn.getAttribute('data-advert-partnerid'),
            partnerName: partnerFPBtn.getAttribute('data-advert-partnername'),
            advertId: partnerFPBtn.getAttribute('data-advert-advertid'),
            loadedData: {
                partnerId: partnerFPBtn.getAttribute('data-advert-partnerid'),
                partnerName: partnerFPBtn.getAttribute('data-advert-partnername'),
                advertId: partnerFPBtn.getAttribute('data-advert-advertid'),
            },
        },
    });
};
var initFPSellerBtnListener = function () {
    return function (dispatch) {
        var url = window.location.href;
        var params = new URL(url).searchParams;
        var sellerDrawer = params.get('sellerinformation');
        if (sellerDrawer) {
            return;
        }
        document.querySelector('body').addEventListener('click', function (e) {
            var partnerFPBtnContainer = e.target.closest('.buyBoxCta');
            if (partnerFPBtnContainer) {
                var partnerFPBtn = partnerFPBtnContainer.querySelector('[data-advert-popin][data-advert-productid]');
                if (partnerFPBtn) {
                    e.preventDefault();
                    dispatchShowSellerDrawer(dispatch, partnerFPBtn);
                }
            }
            else {
                var partnerFPBtn = e.target.closest('.seller-information-cta[data-advert-popin][data-advert-productid]');
                if (partnerFPBtn) {
                    e.preventDefault();
                    dispatchShowSellerDrawer(dispatch, partnerFPBtn);
                }
            }
        });
    };
};
var handleLogin = function (sellerId) {
    var specificId = "10202".concat(sellerId);
    var url = window.location.pathname + window.location.search + "&addtofavorite=true";
    window.location.assign("/connect?action=authenticate&c=87&fastregister=false&url=".concat(encodeURIComponent(url), "&zendesk=false&ajx_param=favorite&ajx_value=submit_10202_").concat(specificId));
};
var addFavoriteSeller = function (partnerId) {
    return function (dispatch) {
        dispatch({ type: ADD_FAVORITE_SELLER_LOADING });
        service.addSellerToFavorites(partnerId).then(function (response) {
            dispatch({
                type: ADD_FAVORITE_SELLER_SUCCESS,
                payload: response.data
            });
        }).catch(function (err) {
            console.log("erreur", err);
            if (err.response.status === 403) {
                handleLogin(partnerId);
            }
        });
    };
};
var removeFavoriteSeller = function (partnerId) {
    return function (dispatch) {
        dispatch({ type: REMOVE_FAVORITE_SELLER_LOADING });
        service.removeSellerFromFavorites(partnerId).then(function (response) {
            dispatch({
                type: REMOVE_FAVORITE_SELLER_SUCCESS,
                payload: response.data
            });
        }).catch(function (err) {
            console.log("erreur", err);
            if (err.response.status === 403) {
                handleLogin(partnerId);
            }
        });
    };
};
var loadSellerData = function (sellerName) {
    return function (dispatch) {
        if (sellerName === '' || typeof sellerName === 'undefined') {
            return;
        }
        service.getSellerInformation(sellerName).then(function (response) {
            dispatch({
                type: FETCH_SELLER_DATA_SUCCESS,
                payload: response.data
            });
        }).catch(function (err) {
            dispatch({
                type: FETCH_SELLER_DATA_ERROR,
                payload: err.response ? { status: err.response.status, statusText: err.response.statusText } : err,
            });
        });
    };
};
var loadSellerFavorite = function (sellerId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (sellerId === '' || typeof sellerId === 'undefined') {
                return [2 /*return*/];
            }
            service.getSellerFavorite(sellerId).then(function (response) {
                dispatch({
                    type: FETCH_SELLER_FAVORITE_DATA_SUCCESS,
                    payload: response.data.isSellerFavorite
                });
            }).catch(function (err) {
                dispatch({
                    type: FETCH_SELLER_FAVORITE_DATA_ERROR,
                    payload: err.response ? { status: err.response.status, statusText: err.response.statusText } : err,
                });
            });
            return [2 /*return*/];
        });
    }); };
};
var loadSellerReviews = function (sellerId, sortType, sortOrder, numberOfResults, nextToken) {
    if (sortType === void 0) { sortType = 'RATE'; }
    if (sortOrder === void 0) { sortOrder = 'DESC'; }
    return function (dispatch) {
        if (sellerId === '' || typeof sellerId === 'undefined') {
            return;
        }
        service.getSellerReviews(sellerId, sortType, sortOrder, numberOfResults, nextToken).then(function (response) {
            dispatch({
                type: FETCH_SELLER_REVIEWS_SUCCESS,
                payload: response.data
            });
        }).catch(function (err) {
            dispatch({
                type: FETCH_SELLER_REVIEWS_ERROR,
                payload: err.response ? { status: err.response.status, statusText: err.response.statusText } : err,
            });
        });
    };
};
var loadSellerDescription = function (shopId) {
    return function (dispatch) {
        if (shopId === '' || typeof shopId === 'undefined') {
            return;
        }
        service.getSellerDescription(shopId).then(function (response) {
            dispatch({
                type: FETCH_SELLER_DESCRIPTION_SUCCESS,
                payload: response.data
            });
        }).catch(function (err) {
            dispatch({
                type: FETCH_SELLER_DESCRIPTION_ERROR,
                payload: err.response ? { status: err.response.status, statusText: err.response.statusText } : err,
            });
        });
    };
};

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadPartnerFromEvent: loadPartnerFromEvent,
  loadSellerLink: loadSellerLink,
  initSellerBtnListeners: initSellerBtnListeners,
  initFPSellerBtnListener: initFPSellerBtnListener,
  handleLogin: handleLogin,
  addFavoriteSeller: addFavoriteSeller,
  removeFavoriteSeller: removeFavoriteSeller,
  loadSellerData: loadSellerData,
  loadSellerFavorite: loadSellerFavorite,
  loadSellerReviews: loadSellerReviews,
  loadSellerDescription: loadSellerDescription
});

var SellerInformationDrawer = function (_a) {
    var _b, _c, _d, _e, _f;
    var partnerId = _a.partnerId;
    var eshop = useSelector(function (state) { return state.sellerInformationDrawer && state.sellerInformationDrawer.eshop; });
    var reviewData = useSelector(function (state) { return state.sellerInformationDrawer && state.sellerInformationDrawer.reviews; });
    var descriptionData = useSelector(function (state) { return state.sellerInformationDrawer && state.sellerInformationDrawer.description; });
    var _g = useState('detail'), target = _g[0], setTarget = _g[1];
    var _h = useState(), reviews = _h[0], setReviews = _h[1];
    var _j = useState('RATE'), sortType = _j[0], setSortType = _j[1];
    var _k = useState('DESC'), sortOrder = _k[0], setSortOrder = _k[1];
    var _l = useState(), nextToken = _l[0], setNextToken = _l[1];
    var _m = useState(false), hasMoreReview = _m[0], setHasMoreReview = _m[1];
    var showPopin = useSelector(function (state) { return state.sellerInformationDrawer && state.sellerInformationDrawer.showPopin; });
    var favoriteSeller = useSelector(function (state) { var _a; return state.sellerInformationDrawer && ((_a = state.sellerInformationDrawer) === null || _a === void 0 ? void 0 : _a.favoriteSeller); });
    var dispatch = useDispatch();
    var md = useSelector(function (state) { return state.md; });
    var isMobile = ((_b = md === null || md === void 0 ? void 0 : md.wsParams) === null || _b === void 0 ? void 0 : _b.isMobile) || false;
    var t = useTranslate('seller-information-drawer').t;
    var sortOptions = [
        {
            value: 'CREATION_DATE_DESC',
            label: t('recent_comments', 'Les plus récents'),
            ts: 'recent_comments',
        },
        {
            value: 'CREATION_DATE_ASC',
            label: t('old_comments', 'Les plus anciens'),
            ts: 'old_comments',
        },
        {
            value: 'RATE_DESC',
            label: t('heighest_rate', 'Les meilleures notes'),
            ts: 'heighest_rate',
        },
        {
            value: 'RATE_ASC',
            label: t('lowest_rate', 'Les moins bonnes notes'),
            ts: 'lowest_rate',
        },
    ];
    var marketplace = useMarketplace(['fr']).marketplace;
    useEffect(function () {
        var params = new URLSearchParams(window.location.search);
        var targetParam = params.get('target') || 'detail';
        setTarget(targetParam);
    }, [showPopin]);
    useEffect(function () {
        if (typeof window !== 'undefined') {
            var mainUrl = window.location.pathname;
            if (mainUrl.includes('/boutique')) {
                var params = new URLSearchParams(window.location.search);
                var targetParam = params.get('target') || 'detail';
                setTarget(targetParam);
            }
        }
        if (reviewData) {
            if (!(reviewData === null || reviewData === void 0 ? void 0 : reviewData.nextToken)) {
                setHasMoreReview(false);
                setNextToken(undefined);
            }
            else {
                setNextToken(reviewData === null || reviewData === void 0 ? void 0 : reviewData.nextToken);
                setHasMoreReview(true);
            }
            var res = __spreadArray(__spreadArray([], ((reviews === null || reviews === void 0 ? void 0 : reviews.ratings) || []), true), ((reviewData === null || reviewData === void 0 ? void 0 : reviewData.ratings) || []), true);
            setReviews({
                ratings: res,
                nextToken: reviewData === null || reviewData === void 0 ? void 0 : reviewData.nextToken,
            });
        }
    }, [reviewData]);
    useEffect(function () {
        var _a;
        dispatch(loadSellerReviews(((_a = eshop === null || eshop === void 0 ? void 0 : eshop.id) === null || _a === void 0 ? void 0 : _a.toString()) || '', sortType, sortOrder, 20, nextToken || undefined));
    }, [eshop, sortOrder, sortType]);
    useEffect(function () {
        dispatch(loadSellerDescription((partnerId === null || partnerId === void 0 ? void 0 : partnerId.toString()) || ''));
    }, [partnerId]);
    var handleFavorites = function () {
        if (favoriteSeller) {
            dispatch(removeFavoriteSeller(partnerId));
        }
        else {
            dispatch(addFavoriteSeller(partnerId));
        }
    };
    var handleLoadMore = function () {
        if (hasMoreReview) {
            dispatch(loadSellerReviews((eshop === null || eshop === void 0 ? void 0 : eshop.id.toString()) || '', sortType, sortOrder, 20, nextToken || undefined));
        }
    };
    return (React.createElement(Box, null,
        React.createElement(SellerDrawer, __assign({ open: showPopin, onClose: function () {
                dispatch({
                    type: CLEAR_SELLER_INFORMATION_DATA,
                });
                setTarget('detail');
                var params = new URLSearchParams(window.location.search);
                if (params.get('sellerinformation')) {
                    params.delete('sellerinformation');
                    params.delete('partnerid');
                    params.delete('partnername');
                    params.delete('advertid');
                    params.delete('favoriteseller');
                    params.delete('addtofavorite');
                    params.delete('target');
                    var query = params.toString();
                    var hash = window.location.hash;
                    var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname).concat(query.length > 0 ? "?".concat(query) : '').concat(hash.length > 1 ? hash : '');
                    window.history.pushState({ path: newUrl }, '', newUrl);
                }
            }, target: target, setTarget: setTarget, title: t('drawer_title', 'À propos du vendeur'), seller: eshop, reviews: reviews, sellerDescription: descriptionData, setNextToken: setNextToken, setSortOrder: setSortOrder, setSortType: setSortType, sellerLogin: eshop === null || eshop === void 0 ? void 0 : eshop.eshopName, setReviews: setReviews, getMoreReviews: handleLoadMore, hasMoreReview: hasMoreReview, sellerCertification: eshop.certified, showFavorite: marketplace === 'fr' && { showFavorite: !isMobile }, isShowButton: marketplace === 'fr' }, (marketplace === 'fr' && { showFavorite: !isMobile }), { isFavorite: favoriteSeller, handleFavorite: function () { return handleFavorites(); }, firstTabTitle: t('first_tab_title', 'Détails vendeur'), secondTabTitle: t('second_tab_itle', 'Avis sur le vendeur'), sellerType: (eshop === null || eshop === void 0 ? void 0 : eshop.isPro)
                ? t('seller_pro', 'Pro')
                : (eshop === null || eshop === void 0 ? void 0 : eshop.isCrew)
                    ? t('seller_partner', 'Site partenaire')
                    : t('seller_particular', 'Particulier'), favoriteButtonText: t('favorite', 'Favoris'), memberText: t('member', 'Membre depuis'), replyText: t('reply', 'Temps de réponse'), acceptanceRateText: t('acceptance', "Taux d'acceptation"), expeditionText: t('expedition', 'Pays d’expédition'), sortText: t('sort', 'Trier par'), commentText: t('comment', 'avis'), loadMoreText: t('load_more', "Charger plus d'avis +"), translatedOptions: sortOptions, newVendorText: t('new_vendor', 'Nouveau vendeur'), saleText: t('sale', 'Vente'), salesText: t('sales', 'Ventes'), largeSalesText: t('large_sales', '+ de 1 000'), textOn: t('on', 'sur'), ctaText: t('visit_shop', 'Voir la boutique'), theText: t('the_text', 'le'), titleDataTs: "drawer_title", firstTabDataTs: "first_tab_title", secondDataTs: "second_tab_itle", sellerTypeDataTs: (eshop === null || eshop === void 0 ? void 0 : eshop.isPro) ? 'seller_pro' : (eshop === null || eshop === void 0 ? void 0 : eshop.isCrew) ? 'seller_partner' : 'seller_particular', favoriteButtonDataTs: "favorite", memberDataTs: "member", replyDataTs: "reply", acceptanceRateDataTs: "acceptance", expeditionDataTs: "expedition", sortDataTs: "sort", commentDataTs: "commentText", loadMoreDataTs: "loadMoreText", 
            // transitionDuration={}
            newVendorDataTs: "new_vendor", saleDataTs: "sale", salesDataTs: "sales", largeSalesDataTs: "large_sales", ctaDataTs: "visit_shop", theDataTs: "the_text", legalMentionsTs: "legal_mentions", legalMentions: t('legal_mentions', 'Mentions légales'), partnershipTs: "partnership", partnership: t('partnership', "Cette boutique est le fruit d\u2019un partenariat entre Rakuten et ".concat(((_c = eshop === null || eshop === void 0 ? void 0 : eshop.legalNotice) === null || _c === void 0 ? void 0 : _c.eshopName) || '', ". Ce partenariat permet au partenaire\n            de diffuser les offres commerciales accessibles depuis son site ").concat(((_d = eshop === null || eshop === void 0 ? void 0 : eshop.legalNotice) === null || _d === void 0 ? void 0 : _d.crewDomain) || '', " directement sur Rakuten."), {
                eshopName: ((_e = eshop === null || eshop === void 0 ? void 0 : eshop.legalNotice) === null || _e === void 0 ? void 0 : _e.eshopName) || (eshop === null || eshop === void 0 ? void 0 : eshop.eshopName) || '',
                crewDomain: ((_f = eshop === null || eshop === void 0 ? void 0 : eshop.legalNotice) === null || _f === void 0 ? void 0 : _f.crewDomain) || '',
            }), phoneTs: "phone", phone: t('phone', 'Téléphone:'), sirenTs: "siren", siren: t('siren', 'N° de SIREN:'), vatTs: "vat", vat: t('vat', 'N° TVA intracommunautaire:'), formTs: "form", form: t('form', 'Forme Juridique:'), capitalTs: "capital", capital: t('capital', 'Capital Social:'), iduTs: "idu", idu: t('idu', 'IDU:'), aboutUsText: t('about_us', 'Qui sommes-nous ?'), aboutUsTs: "about_us" }))));
};

var about_us$3 = "Qui sommes-nous ?";
var acceptance$3 = "Taux d'acceptation";
var capital$3 = "Capital Social:";
var comment$3 = "avis";
var drawer_title$3 = "À propos du vendeur";
var expedition$3 = "Pays d'expédition";
var favorite$3 = "Favoris";
var first_tab_title$3 = "Détails vendeur";
var form$3 = "Forme Juridique:";
var heighest_rate$3 = "Les meilleures notes";
var idu$3 = "IDU:";
var large_sales$3 = "+ de 1 000";
var legal_mentions$3 = "Mentions légales";
var load_more$3 = "Charger plus d'avis +";
var lowest_rate$3 = "Les moins bonnes notes";
var member$3 = "Membre depuis";
var new_vendor$3 = "Nouveau vendeur";
var old_comments$3 = "Les plus anciens";
var on$3 = "sur";
var partnership$3 = "Cette boutique est le fruit d’un partenariat entre Rakuten et {eshopName}. Ce partenariat permet au partenaire de diffuser les offres commerciales accessibles depuis son site {crewDomain} directement sur Rakuten.";
var phone$3 = "Téléphone:";
var recent_comments$3 = "Les plus récents";
var reply$3 = "Temps de réponse";
var sale$3 = "vente";
var sales$3 = "ventes";
var second_tab_itle$3 = "Avis sur le vendeur";
var seller_particular$3 = "Particulier";
var seller_partner$3 = "Site partenaire";
var seller_pro$3 = "Pro";
var siren$3 = "N° de SIREN:";
var sort$3 = "Trier par";
var the_text$3 = "le";
var vat$3 = "N° TVA intracommunautaire:";
var visit_shop$3 = "Voir la boutique";
var localeFr = {
	about_us: about_us$3,
	acceptance: acceptance$3,
	capital: capital$3,
	comment: comment$3,
	drawer_title: drawer_title$3,
	expedition: expedition$3,
	favorite: favorite$3,
	first_tab_title: first_tab_title$3,
	form: form$3,
	heighest_rate: heighest_rate$3,
	idu: idu$3,
	large_sales: large_sales$3,
	legal_mentions: legal_mentions$3,
	load_more: load_more$3,
	lowest_rate: lowest_rate$3,
	member: member$3,
	new_vendor: new_vendor$3,
	old_comments: old_comments$3,
	on: on$3,
	partnership: partnership$3,
	phone: phone$3,
	recent_comments: recent_comments$3,
	reply: reply$3,
	sale: sale$3,
	sales: sales$3,
	second_tab_itle: second_tab_itle$3,
	seller_particular: seller_particular$3,
	seller_partner: seller_partner$3,
	seller_pro: seller_pro$3,
	siren: siren$3,
	sort: sort$3,
	the_text: the_text$3,
	vat: vat$3,
	visit_shop: visit_shop$3
};

var about_us$2 = "¿Quiénes somos?";
var acceptance$2 = "Tasa de aceptación";
var capital$2 = "Capital Social:";
var comment$2 = "comentario";
var drawer_title$2 = "Acerca del vendedor";
var expedition$2 = "País de envío";
var favorite$2 = "Favoritos";
var first_tab_title$2 = "Detalles vendedor";
var form$2 = "Forma Jurídica:";
var heighest_rate$2 = "Las mejores calificaciones";
var idu$2 = "IDU:";
var large_sales$2 = "+ de 1 000";
var legal_mentions$2 = "Aviso legal";
var load_more$2 = "Cargar más opiniones +";
var lowest_rate$2 = "Las calificaciones más bajas";
var member$2 = "Miembro desde";
var new_vendor$2 = "Nuevo vendedor";
var old_comments$2 = "Los más antiguos";
var on$2 = "encendido";
var partnership$2 = "Esta tienda es el fruto de una colaboración entre Rakuten y {eshopName}. Esta colaboración permite al socio difundir las ofertas comerciales accesibles desde su sitio {crewDomain} directamente en Rakuten.";
var phone$2 = "Teléfono:";
var recent_comments$2 = "Los más recientes";
var reply$2 = "Tiempo de respuesta";
var sale$2 = "venta";
var sales$2 = "ventas";
var second_tab_itle$2 = "Opiniones sobre el vendedor";
var seller_particular$2 = "Particular";
var seller_partner$2 = "Sitio asociado";
var seller_pro$2 = "Pro";
var siren$2 = "N° de SIREN:";
var sort$2 = "Ordenar por";
var the_text$2 = "el";
var vat$2 = "N.º de IVA intracomunitario:";
var visit_shop$2 = "Ver la tienda";
var localeEs = {
	about_us: about_us$2,
	acceptance: acceptance$2,
	capital: capital$2,
	comment: comment$2,
	drawer_title: drawer_title$2,
	expedition: expedition$2,
	favorite: favorite$2,
	first_tab_title: first_tab_title$2,
	form: form$2,
	heighest_rate: heighest_rate$2,
	idu: idu$2,
	large_sales: large_sales$2,
	legal_mentions: legal_mentions$2,
	load_more: load_more$2,
	lowest_rate: lowest_rate$2,
	member: member$2,
	new_vendor: new_vendor$2,
	old_comments: old_comments$2,
	on: on$2,
	partnership: partnership$2,
	phone: phone$2,
	recent_comments: recent_comments$2,
	reply: reply$2,
	sale: sale$2,
	sales: sales$2,
	second_tab_itle: second_tab_itle$2,
	seller_particular: seller_particular$2,
	seller_partner: seller_partner$2,
	seller_pro: seller_pro$2,
	siren: siren$2,
	sort: sort$2,
	the_text: the_text$2,
	vat: vat$2,
	visit_shop: visit_shop$2
};

var about_us$1 = "Chi siamo?";
var acceptance$1 = "Tasso di accettazione";
var capital$1 = "Capitale Sociale:";
var comment$1 = "commento";
var drawer_title$1 = "Informazioni sul venditore";
var expedition$1 = "Paese di spedizione";
var favorite$1 = "Preferiti";
var first_tab_title$1 = "Dettagli venditore";
var form$1 = "Forma Giuridica:";
var heighest_rate$1 = "Le valutazioni più alte";
var idu$1 = "IDU:";
var large_sales$1 = "+ di 1 000";
var legal_mentions$1 = "Informazioni legali";
var load_more$1 = "Carica più recensioni +";
var lowest_rate$1 = "Le valutazioni più basse";
var member$1 = "Membro da";
var new_vendor$1 = "Nuovo venditore";
var old_comments$1 = "I più vecchi";
var on$1 = "su";
var partnership$1 = "Questo negozio è il frutto di una partnership tra Rakuten e {eshopName}. Questa partnership consente al partner di diffondere le offerte commerciali accessibili dal suo sito {crewDomain} direttamente su Rakuten.";
var phone$1 = "Telefono:";
var recent_comments$1 = "I più recenti";
var reply$1 = "Tempo di risposta";
var sale$1 = "vendita";
var sales$1 = "vendite";
var second_tab_itle$1 = "Recensioni sul venditore";
var seller_particular$1 = "Privato";
var seller_partner$1 = "Sito partner";
var seller_pro$1 = "Pro";
var siren$1 = "N° di SIREN:";
var sort$1 = "Ordina per";
var the_text$1 = "il";
var vat$1 = "N° partita IVA intracomunitaria:";
var visit_shop$1 = "Vedi il negozio";
var localeIt = {
	about_us: about_us$1,
	acceptance: acceptance$1,
	capital: capital$1,
	comment: comment$1,
	drawer_title: drawer_title$1,
	expedition: expedition$1,
	favorite: favorite$1,
	first_tab_title: first_tab_title$1,
	form: form$1,
	heighest_rate: heighest_rate$1,
	idu: idu$1,
	large_sales: large_sales$1,
	legal_mentions: legal_mentions$1,
	load_more: load_more$1,
	lowest_rate: lowest_rate$1,
	member: member$1,
	new_vendor: new_vendor$1,
	old_comments: old_comments$1,
	on: on$1,
	partnership: partnership$1,
	phone: phone$1,
	recent_comments: recent_comments$1,
	reply: reply$1,
	sale: sale$1,
	sales: sales$1,
	second_tab_itle: second_tab_itle$1,
	seller_particular: seller_particular$1,
	seller_partner: seller_partner$1,
	seller_pro: seller_pro$1,
	siren: siren$1,
	sort: sort$1,
	the_text: the_text$1,
	vat: vat$1,
	visit_shop: visit_shop$1
};

var about_us = "Quem somos nós?";
var acceptance = "Taxa de aceitação";
var capital = "Capital Social:";
var comment = "comentário";
var drawer_title = "Sobre o vendedor";
var expedition = "País de expedição";
var favorite = "Favoritos";
var first_tab_title = "Detalhes do vendedor";
var form = "Forma Jurídica:";
var heighest_rate = "As melhores notas";
var idu = "IDU:";
var large_sales = "+ de 1 000";
var legal_mentions = "Menções legais";
var load_more = "Carregar mais avaliações +";
var lowest_rate = "As piores notas";
var member = "Membro desde";
var new_vendor = "Novo vendedor";
var old_comments = "Os mais antigos";
var on = "em";
var partnership = "Esta loja é o resultado de uma parceria entre a Rakuten e {eshopName}. Esta parceria permite ao parceiro divulgar as ofertas comerciais acessíveis a partir do seu site {crewDomain} diretamente na Rakuten.";
var phone = "Telefone:";
var recent_comments = "Os mais recentes";
var reply = "Tempo de resposta";
var sale = "venda";
var sales = "vendas";
var second_tab_itle = "Avaliação do vendedor";
var seller_particular = "Particular";
var seller_partner = "Site parceiro";
var seller_pro = "Pro";
var siren = "N.º de SIREN:";
var sort = "Ordenar por";
var the_text = "o";
var vat = "N.º de IVA intracomunitário:";
var visit_shop = "Ver a loja";
var localePt = {
	about_us: about_us,
	acceptance: acceptance,
	capital: capital,
	comment: comment,
	drawer_title: drawer_title,
	expedition: expedition,
	favorite: favorite,
	first_tab_title: first_tab_title,
	form: form,
	heighest_rate: heighest_rate,
	idu: idu,
	large_sales: large_sales,
	legal_mentions: legal_mentions,
	load_more: load_more,
	lowest_rate: lowest_rate,
	member: member,
	new_vendor: new_vendor,
	old_comments: old_comments,
	on: on,
	partnership: partnership,
	phone: phone,
	recent_comments: recent_comments,
	reply: reply,
	sale: sale,
	sales: sales,
	second_tab_itle: second_tab_itle,
	seller_particular: seller_particular,
	seller_partner: seller_partner,
	seller_pro: seller_pro,
	siren: siren,
	sort: sort,
	the_text: the_text,
	vat: vat,
	visit_shop: visit_shop
};

var staticData = {
    'fr-FR:seller-information-drawer': localeFr,
    'es-ES:seller-information-drawer': localeEs,
    'it-IT:seller-information-drawer': localeIt,
    'pt-PT:seller-information-drawer': localePt,
};

var logger = getLogger('sellerInformationDrawer');
var initialAction = function (watchContext, baseUrl, preloadedConfig) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var promises, language, tolgee, staticDataSSR;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promises = [];
                    if (watchContext) {
                        logger.debug('initialAction triggered');
                    }
                    if (!(typeof window === 'undefined')) return [3 /*break*/, 2];
                    language = getLanguageFromRequest(watchContext.req);
                    tolgee = getTolgee({
                        language: language,
                        staticData: staticData,
                        ns: ['seller-information-drawer'],
                    });
                    return [4 /*yield*/, tolgee.loadRequired({ language: language })];
                case 1:
                    staticDataSSR = _a.sent();
                    promises.push(dispatch(tolgeeModule.actions.addTolggeStaticData(staticDataSSR)));
                    _a.label = 2;
                case 2: return [2 /*return*/, Promise.all(promises)];
            }
        });
    }); };
};

var Container = function () {
    var partnerId = useSelector(function (state) { var _a; return state.sellerInformationDrawer && ((_a = state.sellerInformationDrawer) === null || _a === void 0 ? void 0 : _a.partnerId); });
    var partnerName = useSelector(function (state) { var _a; return state.sellerInformationDrawer && ((_a = state.sellerInformationDrawer) === null || _a === void 0 ? void 0 : _a.partnerName); });
    var favoriteSeller = useSelector(function (state) { var _a; return state.sellerInformationDrawer && ((_a = state.sellerInformationDrawer) === null || _a === void 0 ? void 0 : _a.favoriteSeller); });
    var dispatch = useDispatch();
    var handleLoadPartner = function (event) {
        dispatch(loadPartnerFromEvent(event.detail.partnerId, event.detail.partnerName, event.detail.advertId, event.detail.target));
    };
    useEffect(function () {
        document.addEventListener('SELLER-INFORMATION-DRAWER', handleLoadPartner);
        dispatch(loadSellerLink());
        dispatch(initSellerBtnListeners);
        return function () {
            document.removeEventListener('SELLER-INFORMATION-DRAWER', handleLoadPartner);
        };
    }, []);
    useEffect(function () {
        dispatch(loadSellerData(partnerName));
    }, [partnerName]);
    useEffect(function () {
        dispatch(loadSellerFavorite(partnerId));
    }, [partnerId]);
    useEffect(function () {
        dispatch(initFPSellerBtnListener());
    }, []);
    useEffect(function () {
        var url = window.location.href;
        var params = new URL(url).searchParams;
        var shouldAddToFavorite = params.get('addtofavorite') === 'true';
        var sellerIdParam = params.get('partnerid');
        if (shouldAddToFavorite) {
            dispatch(favoriteSeller ? removeFavoriteSeller(sellerIdParam) : addFavoriteSeller(sellerIdParam));
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(SellerInformationDrawer, { partnerId: partnerId })));
};
var mapStateToProps = function (state) {
    var sellerInformationDrawer = state.sellerInformationDrawer;
    return __assign({}, sellerInformationDrawer);
};
var mapDispatchToProps = function (dispatch) { return ({
    initialAction: function (context, baseUrl, preloadedConfig) { return dispatch(initialAction(context)); },
}); };
var ConnectedSellerInformationDrawer = connect(mapStateToProps, mapDispatchToProps)(Container);
var BreakpointWrappedSellerInformationDrawer = function () {
    var _a, _b, _c;
    return (React.createElement(TolgeeProvider, { ns: ['seller-information-drawer'], apiKey: (_b = (_a = publicRuntimeConfig.tolgee) === null || _a === void 0 ? void 0 : _a.apiKey) === null || _b === void 0 ? void 0 : _b['next-common'], apiUrl: (_c = publicRuntimeConfig.tolgee) === null || _c === void 0 ? void 0 : _c.apiUrl, staticData: staticData },
        React.createElement(MarketplaceProvider, null,
            React.createElement(BreakpointProvider, null,
                React.createElement(ConnectedSellerInformationDrawer, null)))));
};
var SellerInformationDrawerContainer = BreakpointWrappedSellerInformationDrawer;

var NAME = 'sellerInformationDrawer';
var DEFAULT_STATE = {};
var initialState = {
    partnerId: '',
    partnerName: '',
    favoriteSeller: false,
    advertId: '',
    showPopin: false,
    isReady: false,
    loading: false,
    eshop: {},
    reviews: {},
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NAME: NAME,
  DEFAULT_STATE: DEFAULT_STATE,
  initialState: initialState
});

function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SHOW_SELLER_INFORMATION_DRAWER:
            return __assign(__assign(__assign({}, state), { showPopin: true }), action.payload);
        case INIT_SELLER_INFORMATION_DRAWER:
            return __assign(__assign({}, state), { isReady: true });
        case FETCH_SELLER_FAVORITE_DATA_SUCCESS:
            return __assign(__assign({}, state), { favoriteSeller: action.payload });
        case FETCH_SELLER_FAVORITE_DATA_ERROR:
            return __assign(__assign({}, state), action.payload);
        case ADD_FAVORITE_SELLER_SUCCESS:
            return __assign(__assign({}, state), { favoriteSeller: true });
        case REMOVE_FAVORITE_SELLER_SUCCESS:
            return __assign(__assign({}, state), { favoriteSeller: false });
        case CLEAR_SELLER_INFORMATION_DATA:
            return __assign(__assign({}, state), { partnerName: '', partnerId: '', advertId: '', favoriteSeller: false, showPopin: false });
        case FETCH_SELLER_DATA_SUCCESS:
            return __assign(__assign({}, state), { eshop: action.payload });
        case FETCH_SELLER_DATA_ERROR:
            return __assign(__assign({}, state), action.payload);
        case FETCH_SELLER_REVIEWS_SUCCESS:
            return __assign(__assign({}, state), { reviews: action.payload });
        case FETCH_SELLER_REVIEWS_ERROR:
            return __assign(__assign({}, state), action.payload);
        case FETCH_SELLER_DESCRIPTION_SUCCESS:
            return __assign(__assign({}, state), { description: action.payload });
        case FETCH_SELLER_DESCRIPTION_ERROR:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}

var containers = { SellerInformationDrawerContainer: SellerInformationDrawerContainer };
var sellerInformationDrawerModule = { containers: containers, actions: actions, constants: constants, reducer: reducer, initalAction: initialAction };

export { sellerInformationDrawerModule as default };
